import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-leveringsvoorwaarden',
  templateUrl: '../../../assets/html/leveringsvoorwaarden.html',
  styleUrls: ['./leveringsvoorwaarden.component.css']
})
export class LeveringsvoorwaardenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
